/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  // InputGroupText,
  // InputGroup,
  Input,
  // Row,
  // Col,
  // Card,
  // CardText,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
// import arrow_icon from "../../assets/arrow_sign.svg";

import { FiShare2 } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import {
  // AiOutlinePlus,
  // AiFillCheckCircle,
  AiOutlineArrowLeft,
} from "react-icons/ai";
// import { BiDotsVerticalRounded } from "react-icons/bi";
import {
  MdLocationOn,
  MdOutlineFeedback,
  MdOutlineNavigateNext,
  // MdOutlineSearch,
} from "react-icons/md";
import ShareModal from "../../components/Modals/ShareModal";
import ReportSuggestionModal from "../../components/Modals/ReportSuggestionModal";
import { useDispatch } from "react-redux";
import useDebounce from "../../components/Debounce/Debounce";
import { useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../utils/action/Action";
import {
  placesByCategory,
  tzadikimCategory,
} from "../../services/category.service";
import NoDataFound from "../../components/NoDataFound/NoDataFound";
// import {
//   addUserFavorite,
//   removeUserFavorite,
// } from "../../services/favourites.service";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Pagination from "../../components/Pagination/Pagination";
import { updateRouteDetail } from "../../services/myRoute.service";
import "./AddMorePointsToRoute.scss";
import { slice } from "lodash";
import { getSearchEverywhere } from "../../services/search.service";
// import marked_pop from "../../assets/marked_pop.svg";
import { GoHome, GoPlus } from "react-icons/go";
// import filter_icon from "../../assets/filter_icon.svg";
// import AddMorePointsToRouteDetails from "./AddMorePointsToRouteDetails";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { HiDotsVertical, HiLocationMarker } from "react-icons/hi";
import { IoCheckmark, IoNavigateSharp, IoShareSocial } from "react-icons/io5";
import { API_URL } from "../../config/config";
import ContainerLayout from "../../layout/ContainerLayout";

export const categoryItems = [
  // {
  //   id: 12,
  //   title: "Tzadikim",
  //   showTitle: "צדיקים",
  //   src: require("../../assets/catergory_image1A.png"),
  //   icon: require("../../assets/catergory_image2B.png"),
  // },
  {
    id: 1,
    title: "Cemeteries",
    showTitle: "בית החיים",
    src: require("../../assets/catergory_image2A.png"),
    icon: require("../../assets/catergory_image2B.png"),
  },
  {
    id: 7,
    title: "Mikvah",
    showTitle: "מקוה",
    src: require("../../assets/catergory_image3A.png"),
    icon: require("../../assets/catergory_image3B.png"),
  },
  {
    id: 2,
    title: "Synagogues",
    showTitle: "בית המדרש",
    src: require("../../assets/catergory_image4A.png"),
    icon: require("../../assets/catergory_image4B.png"),
  },
  {
    id: 5,
    title: "Food",
    showTitle: "מזון",
    src: require("../../assets/catergory_image5A.png"),
    icon: require("../../assets/catergory_image5B.png"),
  },
  {
    id: 4,
    title: "Hotels",
    showTitle: "אכסניא",
    src: require("../../assets/catergory_image6A.png"),
    icon: require("../../assets/catergory_image6B.png"),
  },
  {
    id: 10,
    title: "Airports",
    showTitle: "עירפארט",
    src: require("../../assets/catergory_image7A.png"),
    icon: require("../../assets/catergory_image7B.png"),
  },
  {
    id: 9,
    title: "Historical Places",
    showTitle: "היסטאריע",
    src: require("../../assets/catergory_image8A.png"),
    icon: require("../../assets/catergory_image8B.png"),
  },
];

function AddMorePointsToRoute({ isUserLoggedIn }) {
  const location = useLocation();

  const [dropdownMenuOpen, setMenuOpen] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  // const [routeName, setRouteName] = useState(null);
  const [pointName, setPointName] = useState(null);
  const [dropdownOpen, setOpen] = useState(false);
  const [dropDownValue, setDropDownValue] = useState("All / הכל");
  const [link, setLink] = useState("");
  const [categoryItem, setCategoryItem] = useState([]);
  const [routePoint, setRoutePoint] = useState(location?.state?.data[0]?.arr);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalCount, setTotalCount] = useState();
  const [totalRecords, setTotalRecords] = useState("");
  const [checkForFavorite, setCheckForFavorite] = useState(null);
  const [mkmID, setMkmId] = useState();
  const [debouceValue, setDebouceValue] = useState("");
  const [AllPlaces, setAllPlaces] = useState([]);
  const [values, setValues] = useState({
    search: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const debounce = useDebounce();
  const [isHover, setIsHover] = useState("");
  const [openIndex, setOpenIndex] = useState(0);

  const [myIndex, setMyIndex] = useState([50, 50, 50, 50, 50, 50, 50, 50]);

  const email = useSelector(
    (state) => state?.userDetailReducer?.userData?.email
  );
  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );

  var regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  useEffect(() => {
    console.log("routePoint", location?.state?.data[0]);
    if (values?.search?.length > 0) {
      if (values?.search?.length > 2) {
        dropDownValue === "Tzadikim" ? tzadikimPlace() : searchAPi();
      } else {
        toast.info("Please enter atleast 3 characters to get result.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }
    } else {
      if (dropDownValue === "Tzadikim") {
        tzadikimPlace();
      } else {
        places();
      }
    }
  }, [debouceValue, currentPage, pageSize, dropDownValue]);

  const searchAPi = async () => {
    let obj = {
      filter: values?.search?.trim(),
      email: userName,
      checkForFavorite: true,
    };
    await getSearchEverywhere(obj)
      .then((res) => {
        let category = "";
        if (dropDownValue === "Historical Places / היסטאריע") {
          category = "historical";
        } else if (dropDownValue === "Hotels / אכסניא") {
          category = "motels";
        } else if (dropDownValue === "Synagogues / בית המדרש") {
          category = "synagogues";
        } else if (dropDownValue === "Airports / עירפארט") {
          category = "airports";
        } else if (dropDownValue === "Mikvah / מקוה") {
          category = "mikvah";
        } else if (dropDownValue === "Cemeteries / בית החיים") {
          category = "cemeteries";
        } else if (dropDownValue === "Tzadikim / צדיקים") {
          category = "Tzadikim";
        } else if (dropDownValue === "Food / מזון") {
          category = "food";
        }

        let items = [];

        Object.keys(res.data.data).map((item) => {
          if (res.data.data[item].length > 0) {
            if (category === item) {
              return setCategoryItem(res.data.data[item]);
            }

            let val = {
              title: item.slice(0, 1).toLocaleUpperCase() + item.slice(1),
              items: res.data.data[item],
            };
            return items.push(val);
          }
          return null;
        });

        setAllPlaces(items);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setTotalRecords(totalCount);
  }, [totalCount]);

  const addToRoute = (id) => {
    if (location?.state?.data[0]?.key === "addPointAbove") {
      addPointAbove(id);

      console.log("routePoint", routePoint);
    } else if (location?.state?.data[0]?.key === "addPoints") {
      addPointInLast(id);
      console.log("routePoint", routePoint);
    } else {
      setMkmId(id);
    }
  };

  const addPointAbove = async (id) => {
    if (isUserLoggedIn) {
      const arr = location?.state?.data[0]?.arr;

      if (arr?.length < 25) {
        const index = location?.state?.data[0]?.index;
        let requestBody = [];
        arr?.splice(index, 0, {
          mkmID: id,
          orderNumber: 0,
          visited: false,
        });
        requestBody = arr?.map((item, i) => {
          return {
            mkmID: item?.place?.mkmID || item?.mkmID,
            orderNumber: i,
            visited: item?.visited,
          };
        });

        try {
          let res = await updateRouteDetail(requestBody, {
            userName: userName,
            routeID: location?.state?.data[0]?.route_id,
          });
          console.log("res", res);
          if (res && res?.status === 200) {
            toast.success("Point Added Successfully In Your Route!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });

            setRoutePoint(res?.data);
          }
        } catch (err) {
          toast.error(
            err?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      } else {
        toast.warning(
          "Max of only 25 points can be added to a route, Kindly remove a point to add a new point.",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this point in your Route?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const addPointInLast = async (id) => {
    if (isUserLoggedIn) {
      const arr = location?.state?.data[0].arr;
      console.log("====================================");
      console.log("arrrrrrrr", arr);
      console.log("====================================");
      if (arr?.length < 25) {
        let index = location?.state?.data[0]?.index;
        index = arr.length;
        let requestBody = [];
        arr?.splice(index, 0, {
          mkmID: id,
          orderNumber: 0,
          visited: false,
        });
        requestBody = arr?.map((item, i) => {
          return {
            mkmID: item?.place?.mkmID || item?.mkmID,
            orderNumber: i,
            visited: item?.visited,
          };
        });

        try {
          let res = await updateRouteDetail(requestBody, {
            userName: userName,
            routeID: location?.state?.data[0]?.route_id,
          });

          if (res && res?.status === 200) {
            toast.success("Point Added Successfully In Your Route!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
            console.log("res", res);
            setRoutePoint(res?.data?.data);
            console.log("====================================");
            console.log("rrrrrrrrr", routePoint);
            console.log("====================================");
            console.log(res?.data?.data);
            console.log("====================================");
          }
        } catch (err) {
          toast.error(
            err?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      } else {
        toast.warning(
          "Max of only 25 credits can be added to a route, Kindly remove a point to add a new point.",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this point in your Route?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const share = (id, poi) => {
    var data;
    if (dropDownValue === "Tzadikim") {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-details/${id}/${poi}`;
      setLink(data);
    } else {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id}/${poi}`;
      setLink(data);
    }
    setShowShareModal(true);
  };

  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };

  const changeValue = (e) => {
    dispatch(showLoader());
    setOpen(false);
    setTimeout(() => {
      setDropDownValue(e?.target?.value);
    }, 1000);
    setCategoryItem([]);
    // clear the current table data
    // let currentTableData = [];
    setDropDownValue(e?.target?.value);
    e?.target?.value === "Tzadikim / צדיקים" ? tzadikimPlace() : places();
    dispatch(hideLoader());
  };

  const places = async () => {
    dispatch(showLoader());
    if (AllPlaces.title === "Motels") {
      places.title = "Hotels";
    }

    let category = "";
    if (dropDownValue === "Historical Places / היסטאריע") {
      category = "historical";
    } else if (dropDownValue === "Hotels / אכסניא") {
      category = "motels";
    } else if (dropDownValue === "Synagogues / בית המדרש") {
      category = "synagogues";
    } else if (dropDownValue === "Airports / עירפארט") {
      category = "airports";
    } else if (dropDownValue === "Mikvah / מקוה") {
      category = "mikvah";
    } else if (dropDownValue === "Cemeteries / בית החיים") {
      category = "cemeteries";
    } else if (dropDownValue === "Tzadikim / צדיקים") {
      category = "Tzadikim";
    } else if (dropDownValue === "Food / מזון") {
      category = "food";
    } else if (dropDownValue === "All / הכל") {
      category = "all";
    }
    try {
      setCategoryItem([]);
      if (category !== "all" && category !== "Tzadikim") {
        console.log("fetching.........", category);
        const response = await placesByCategory(
          {
            Category: category.toLowerCase(),
            Filter: values?.search,
            email: email,
            checkForFavorite: true,
          },
          {
            pageNumber: currentPage,
            pageSize: 84,
          }
        );
        if (response && response?.status === 200) {
          console.log("dataaaaaa", response?.data);
          setCategoryItem(response?.data?.data?.data);
          setCurrentPage(response?.data?.data?.pageNumber);
          setPageSize(pageSize);
          setTotalCount(response?.data?.data?.totalCount);
        }
        dispatch(hideLoader());
      } else if (category === "Tzadikim") {
        tzadikimPlace();
      } else {
        // call all api and merge the data and push them in categoryItem
        let items = [];
        for (let i = 0; i < categoryItems.length; i++) {
          let category = "";
          if (categoryItems[i].title === "Tzadikim") {
            category = "Tzadikim";
          } else if (categoryItems[i].title === "Historical Places") {
            category = "historical";
          } else if (categoryItems[i].title === "Hotels") {
            category = "motels";
          } else if (categoryItems[i].title === "Synagogues") {
            category = "synagogues";
          } else if (categoryItems[i].title === "Airports") {
            category = "airports";
          } else if (categoryItems[i].title === "Mikvah") {
            category = "mikvah";
          } else if (categoryItems[i].title === "Cemeteries") {
            category = "cemeteries";
          } else if (categoryItems[i].title === "Food") {
            category = "food";
          } else if (categoryItems[i].title === "All") {
            category = "all";
          }

          if (category !== "all") {
            let response;
            let finalResponse = [];

            if (category === "Tzadikim") {
              response = await tzadikimCategory(
                {
                  Category: "Tzadikim",
                  Filter: values?.search,
                  email: email,
                  checkForFavorite: true,
                },
                {
                  pageNumber: currentPage,
                  pageSize: 84,
                }
              );

              let pageNum = currentPage;

              if (response && response?.status === 200) {
                finalResponse = [...response?.data?.data?.data];

                const countFetch =
                  (response?.data?.data?.totalCount - 100) / 100 > 0
                    ? (response?.data?.data?.totalCount - 100) % 100 > 0
                      ? (response?.data?.data?.totalCount - 100) / 100 +
                        1 -
                        ((response?.data?.data?.totalCount - 100) % 100) / 100
                      : (response?.data?.data?.totalCount - 100) / 100
                    : 0;
                // console.log("count feeeeetch tzadkim", countFetch)
                // for (let j = 0; j < countFetch; j++) {
                //   pageNum++;
                //   const res = await placesByCategory(
                //     {
                //       Category: "Tzadikim",
                //       Filter: values?.search,
                //       email: email,
                //       checkForFavorite: true,
                //     },
                //     {
                //       pageNumber: pageNum,
                //       pageSize: 84,
                //     }
                //   );
                //   if (res && res?.status === 200) {
                //     finalResponse = [
                //       ...finalResponse,
                //       ...res?.data?.data?.data,
                //     ];
                //   }
                // }
              }
            } else {
              response = await placesByCategory(
                {
                  Category: category,
                  Filter: values?.search,
                  email: email,
                  checkForFavorite: true,
                },
                {
                  pageNumber: currentPage,
                  pageSize: 84,
                }
              );

              let pageNum = currentPage;

              if (response && response?.status === 200) {
                finalResponse = [...response?.data?.data?.data];

                const countFetch =
                  (response?.data?.data?.totalCount - 100) / 100 > 0
                    ? (response?.data?.data?.totalCount - 100) % 100 > 0
                      ? (response?.data?.data?.totalCount - 100) / 100 +
                        1 -
                        ((response?.data?.data?.totalCount - 100) % 100) / 100
                      : (response?.data?.data?.totalCount - 100) / 100
                    : 0;
                // console.log("count feeeeetch", countFetch)
                for (let j = 0; j < countFetch; j++) {
                  pageNum++;
                  const res = await placesByCategory(
                    {
                      Category: category,
                      Filter: values?.search,
                      email: email,
                      checkForFavorite: true,
                    },
                    {
                      pageNumber: pageNum,
                      pageSize: 84,
                    }
                  );
                  if (res && res?.status === 200) {
                    finalResponse = [
                      ...finalResponse,
                      ...res?.data?.data?.data,
                    ];
                  }
                }
              }
            }

            if (response && response?.status === 200) {
              // i want store all the data in one array but each one in different index with name of category
              // items.push({title: categoryItems[i].title, items: response?.data?.data?.data})
              items.push({
                title: categoryItems[i].title,
                items: finalResponse,
              });
            }
          }
        }
        setAllPlaces(items);
        dispatch(hideLoader());
      }
    } catch {
      dispatch(hideLoader());
      setAllPlaces([]);
      setCategoryItem([]);
    }
  };

  // const allPlaces = async () => {};

  const tzadikimPlace = async () => {
    dispatch(showLoader());
    try {
      setCategoryItem([]);
      const response = await tzadikimCategory(
        {
          Category: "Tzadikim",
          Filter: values?.search,
          email: email,
          checkForFavorite: true,
        },
        {
          pageNumber: currentPage,
          pageSize: 84,
        }
      );
      if (response && response?.status === 200) {
        setCategoryItem(response?.data?.data?.data);
        setCurrentPage(response?.data?.data?.pageNumber);
        setPageSize(pageSize);
        setTotalCount(response?.data?.data?.totalCount);
      }
      dispatch(hideLoader());
    } catch {
      dispatch(hideLoader());
      setCategoryItem([]);
    }
  };

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    console.log("first last...", firstPageIndex, lastPageIndex, categoryItem);
    // return categoryItem?.slice(firstPageIndex, lastPageIndex);
    return categoryItem;
  }, [currentPage, categoryItem, pageSize]);

  console.log("all data", currentTableData);
  console.log("all data 1", currentTableData);

  console.log("all 1", AllPlaces);

  const toggleSection = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  // const addToFavorite = async (id, fav) => {
  //   if (isUserLoggedIn) {
  //     let categoryName = Object.keys(id)[0];
  //     const willFavorite = await swal({
  //       title: "Are you sure?",
  //       text: "You want to add this route in Favorites?",
  //       icon: marked_pop,
  //       buttons: true,
  //     });
  //     if (willFavorite) {
  //       try {
  //         const obj = {
  //           userName: userName,
  //         };
  //         const data = {
  //           mkmId: categoryName === "mkmID" ? id?.mkmID : null,
  //           tzId: categoryName === "tzadikimID" ? id?.tzadikimID : null,
  //         };
  //         const response = await addUserFavorite(data, obj);
  //         setCheckForFavorite(fav);
  //         if (response && response?.status === 200) {
  //           swal(
  //             "Added!",
  //             "Your route has been added in Favorites!",
  //             "success"
  //           );
  //           categoryName === "tzadikimID" ? tzadikimPlace() : places();
  //         }
  //       } catch (error) {
  //         toast.error(
  //           error?.response?.data?.message ||
  //             "Oops.. something went wrong, try again !!!",
  //           {
  //             position: toast.POSITION.TOP_RIGHT,
  //             autoClose: 2000,
  //           }
  //         );
  //       }
  //     }
  //   } else {
  //     const notLoggedIn = await swal({
  //       title: "Please Continue to Log In",
  //       text: "You want to add this route in Favorites?",
  //       icon: marked_pop,
  //       buttons: ["Cancel", "Log In"],
  //     });
  //     if (notLoggedIn) {
  //       navigate("/sign-in");
  //     }
  //   }
  // };

  // const removeFromFavorite = async (id, fav) => {
  //   if (isUserLoggedIn) {
  //     let categoryName = Object.keys(id)[0];

  //     const willRemoveFavorite = await swal({
  //       title: "Are you sure?",
  //       text: "You want to remove this route from Favorites?",
  //       icon: marked_pop,
  //       buttons: true,
  //     });
  //     if (willRemoveFavorite) {
  //       try {
  //         const obj = {
  //           userName: userName,
  //         };
  //         const data = {
  //           mkmId: categoryName === "mkmID" ? id?.mkmID : null,
  //           tzId: categoryName === "tzadikimID" ? id?.tzadikimID : null,
  //         };
  //         const response = await removeUserFavorite(data, obj);
  //         setCheckForFavorite(fav);
  //         if (response && response?.status === 200) {
  //           swal(
  //             "Removed!",
  //             "Your route has been removed from Favorites!",
  //             "success"
  //           );
  //           categoryName === "tzadikimID" ? tzadikimPlace() : places();
  //         }
  //       } catch (error) {
  //         toast.error(
  //           error?.response?.data?.message ||
  //             "Oops.. something went wrong, try again !!!",
  //           {
  //             position: toast.POSITION.TOP_RIGHT,
  //             autoClose: 2000,
  //           }
  //         );
  //       }
  //     }
  //   } else {
  //     const notLoggedIn = await swal({
  //       title: "Please Continue to Log In",
  //       text: "You want to remove this route from Favorites?",
  //       icon: marked_pop,
  //       buttons: ["Cancel", "Log In"],
  //     });
  //     if (notLoggedIn) {
  //       navigate("/sign-in");
  //     }
  //   }
  // };

  const handleChange = (e) => {
    const newData = { ...values };
    newData[e?.target?.id] = e?.target?.value?.trim().replace(regex, "");
    setValues(newData);
    debounce(() => setDebouceValue(newData));
  };

  const loadMore = (index) => {
    const apdatedArray = [...myIndex];
    apdatedArray[index] = apdatedArray[index] + 50;
    setMyIndex(apdatedArray);
  };

  return (
    <div className="main_section add_points_route">
      <ReportSuggestionModal
        showReportModal={showReportModal}
        setShowReportModal={setShowReportModal}
        // setRouteName={setRouteName}
        pointName={pointName}
        mkmID={mkmID}
      />
      <ShareModal
        showShareModal={showShareModal}
        setShowShareModal={setShowShareModal}
        link={link}
        setLink={setLink}
      />

      <Container>
        <div className="breadcrumb_section">
          <Breadcrumb className="breadcrumb">
            <BreadcrumbItem>
              <Link to="/" className="breadcrumb_item1">
                <GoHome />
              </Link>
              <span className="breadcrumb-divider">
                <MdOutlineNavigateNext />
              </span>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to="/my-routes" className="breadcrumb_item1">
                My Routes
              </Link>
              <span className="breadcrumb-divider">
                <MdOutlineNavigateNext />
              </span>
            </BreadcrumbItem>
            {/* <BreadcrumbItem>
                <Link to="/my-routes" className="breadcrumb_item1">
                  [Route Name]
                </Link>
                <span className="breadcrumb-divider">
                  <MdOutlineNavigateNext />
                </span>
              </BreadcrumbItem> */}
            {/* <BreadcrumbItem>
                            <Link to="/my-routes-detail" className="breadcrumb_item2">Details</Link>
                        </BreadcrumbItem> */}
            <BreadcrumbItem active>
              <Link to="#" className="breadcrumb_item2">
                Add Points
              </Link>
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
      </Container>

      <div className="add_points_section">
        <ContainerLayout classes={{ maxWidth: "1300px" }}>
          <div className="add_points_box">
            <div className="add_points_box_header_top">
              <div className="add_points_box_header">
                {/* <div className="filter_btn">
                    <button>
                      <img src={filter_icon} /> <span>Filters</span>
                    </button>
                  </div> */}
                <div className="search_input">
                  <IoIosSearch className="icon" />

                  <Input
                    type="search"
                    id="search"
                    name="search"
                    value={values?.search}
                    onChange={handleChange}
                    maxLength="100"
                    placeholder="Search for a place?"
                    autoComplete="off"
                  />
                </div>
                <div className="dropdown">
                  <Dropdown
                    className="addMorePoints_dropdown"
                    toggle={() => {
                      setOpen(!dropdownOpen);
                    }}
                    isOpen={dropdownOpen}
                  >
                    <DropdownToggle>
                      <span>{dropDownValue}</span> <FaChevronDown />
                    </DropdownToggle>
                    <DropdownMenu>
                      {categoryItems?.map((item) => {
                        return (
                          <DropdownItem
                            key={item?.id}
                            onClick={(e) =>
                              changeValue(
                                e,
                                item?.title + " / " + item?.showTitle
                              )
                            }
                            value={item?.title + " / " + item?.showTitle}
                          >
                            {item?.title + " / " + item?.showTitle}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
              <h4>{dropDownValue}</h4>
            </div>
            <div className="add_points_block">
              <div className="add_points_grid_view">
                <div className="item_card">
                  {(currentTableData?.length === 0 ||
                    currentTableData === undefined) &&
                  dropDownValue !== "All / הכל" ? (
                    <NoDataFound />
                  ) : (
                    dropDownValue !== "All / הכל" &&
                    currentTableData?.map((place, index) => (
                      <div
                        className="nt-card"
                        key={index}
                        onClick={() => {
                          if (dropDownValue === "Tzadikim / צדיקים") {
                            navigate(
                              `/category-detail/?tzadikimId=${place?.tzadikimID}&cor=${place?.poi}`,
                              {
                                state: {
                                  from: "addMorePointToRoute",
                                  data: location?.state?.data,
                                  categoryName: "tzadikim",
                                },
                              }
                            );
                          } else {
                            navigate(
                              `/category-detail/?MkmId=${place?.mkmID}&cor=${place?.poi}`,
                              {
                                state: {
                                  from: "addMorePointToRoute",
                                  data: location?.state?.data,
                                  categoryName: dropDownValue
                                    .split("/")[0]
                                    .trim(),
                                },
                              }
                            );
                          }
                        }}
                      >
                        {/* IMAGE */}
                        <div className="nt-card-image">
                          <img
                            src={
                              place?.imageIDs?.length > 0
                                ? `${API_URL}/api/mkm/getimage/${place?.imageIDs?.[0]}`
                                : categoryItems.find(
                                    (item) =>
                                      item.title ===
                                      dropDownValue.split("/")[0].trim()
                                  )?.icon
                            }
                            alt={dropDownValue}
                          />
                        </div>

                        {/* DROPDOWN (More Options) */}
                        <div className="nt-dropdown_list">
                          <Dropdown
                            className="nt-moreInfo"
                            toggle={(e) => {
                              e.preventDefault();
                              e.stopPropagation(); // prevent card click
                              setMenuOpen(
                                index === dropdownMenuOpen ? null : index
                              );
                            }}
                            isOpen={index === dropdownMenuOpen}
                          >
                            <DropdownToggle
                              className="nt-list_icon"
                              caret={false}
                            >
                              <HiDotsVertical size={20} className="nt-list" />
                            </DropdownToggle>

                            <DropdownMenu
                              className="nt-custom_dropdown"
                              modifiers={[
                                {
                                  name: "offset",
                                  options: { offset: [-155, 5] },
                                },
                              ]}
                            >
                              <DropdownItem>
                                <Link
                                  to={`/along-the-way-to-here/${place?.poi}`}
                                  state={{
                                    from: "addMorePointToRoute",
                                    data: location?.state?.data,
                                  }}
                                  className="breadcrumb_item1 hello"
                                  onClick={(e) => e.stopPropagation()} // prevent card click
                                >
                                  <IoNavigateSharp
                                    className="navigate_icon"
                                    size={"18px"}
                                  />
                                  Along the way to here
                                </Link>
                              </DropdownItem>
                              <DropdownItem
                                className="nt-report-suggestion"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  reportSuggestion(
                                    place?.title,
                                    place?.tzadikimID
                                      ? place?.tzadikimID
                                      : place?.mkmID
                                  );
                                }}
                              >
                                <MdOutlineFeedback size={17} />
                                Report suggestion
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>

                        {/* CARD DETAILS */}
                        <div className="nt-card-details">
                          <div
                            className="nt-share-icon"
                            onClick={(e) => {
                              e.stopPropagation(); // prevent card click
                              share(
                                place?.tzadikimID
                                  ? place?.tzadikimID
                                  : place?.mkmID,
                                place?.poi
                              );
                            }}
                          >
                            <FiShare2 size={18} />
                          </div>

                          <div className="nt-title">
                            {dropDownValue === "Tzadikim / צדיקים" ? (
                              <h3>
                                <Link
                                  to={`/category-detail/?tzadikimId=${place?.tzadikimID}&cor=${place?.poi}`}
                                  state={{
                                    from: "addMorePointToRoute",
                                    data: location?.state?.data,
                                    categoryName: "tzadikim",
                                  }}
                                  title={place?.title}
                                  onClick={(e) => e.stopPropagation()} // prevent duplicate navigation
                                >
                                  {place?.title}
                                </Link>
                              </h3>
                            ) : (
                              <h3>
                                <Link
                                  to={`/category-detail/?MkmId=${place?.mkmID}&cor=${place?.poi}`}
                                  state={{
                                    from: "addMorePointToRoute",
                                    data: location?.state?.data,
                                    categoryName: dropDownValue
                                      .split("/")[0]
                                      .trim(),
                                  }}
                                  title={place?.title}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {place?.title}
                                </Link>
                              </h3>
                            )}

                            <h4>
                              {place?.cityY
                                ? place?.cityY.substring(
                                    place?.cityY.indexOf("/") + 1
                                  )
                                : null}
                              {place?.stateY
                                ? " - " +
                                  place?.stateY.substring(
                                    place?.stateY.indexOf("/") + 1
                                  )
                                : null}
                            </h4>
                          </div>
                        </div>

                        {/* CARD FOOTER */}
                        <div className="nt-card-footer">
                          <div className="nt-card_footer-left-side">
                            <div className="nt-location">
                              <MdLocationOn
                                className="location_icon"
                                size={18}
                              />
                              <span>{place?.cityE + " " + place?.stateE}</span>
                            </div>
                            <button
                              className="nt-btn-learn-more"
                              onClick={(e) => e.stopPropagation()} // prevent card click
                            >
                              <Link to="##">Learn More</Link>
                            </button>
                          </div>

                          {/* ADD TO ROUTE BUTTON */}
                          <div className="nt-add_fav">
                            {routePoint.filter(
                              (item) =>
                                item?.place?.mkmID === place?.mkmID ||
                                item.mkmID === place?.mkmID
                            ).length > 0 ? (
                              <button
                                className="add-toRoute"
                                onClick={(e) => e.stopPropagation()} // prevent card click
                              >
                                <IoCheckmark />
                              </button>
                            ) : (
                              <button
                                className="add-ToRoute"
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent card click
                                  addToRoute(place?.mkmID);
                                }}
                              >
                                <GoPlus size={22} />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                {currentTableData?.length === 0 ||
                currentTableData === undefined ? null : (
                  <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={totalRecords > 0 ? totalRecords : null}
                    pageSize={pageSize}
                    onPageChange={(page) => {
                      setCurrentPage(page);
                      window.scrollTo({ top: 0, behavior: "instant" });
                    }}
                  />
                )}
              </div>
            </div>
            <div className="nt-custom_accordion">
              {dropDownValue === "All / הכל"
                ? AllPlaces?.map((Place1, idx) => {
                    const isOpen = openIndex === idx;
                    if (Place1.title === "Motels") {
                      Place1.title = "Hotels";
                    }

                    return (
                      <div
                        key={Place1?.title}
                        className="nt-custom_accordion-body"
                      >
                        {isOpen ? "" : <hr />}

                        {/* Accordion Heading */}
                        <div
                          className="nt-accordion_heading"
                          onClick={() => toggleSection(idx)}
                        >
                          <div className="nt-accordin-icon">
                            {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                          </div>
                          <h3>{Place1?.title}</h3>
                        </div>

                        {/* Accordion Content */}
                        <div
                          className="nt-accordion_inner_content"
                          style={{
                            maxHeight: isOpen ? "" : "0",
                            paddingBlock: isOpen ? "20px" : "0",
                            opacity: isOpen ? "1" : "0",
                            overflow: "hidden",
                            transition: "all 0.3s ease",
                          }}
                        >
                          <section>
                            <div
                              className={`item_card ${
                                AllPlaces?.length <= 2 ? "two-items" : ""
                              }`}
                            >
                              {Place1.items?.length === 0 ||
                              Place1.items === undefined ||
                              Place1.title === "Tzadikim" ? (
                                <NoDataFound />
                              ) : (
                                slice(Place1.items, 0, myIndex[idx])?.map(
                                  (place, index) => (
                                    <div
                                      className="nt-card"
                                      key={index}
                                      onClick={() => {
                                        if (Place1?.title === "Tzadikim") {
                                          navigate(
                                            `/category-detail/?tzadikimId=${place?.tzadikimID}&cor=${place?.poi}`,
                                            {
                                              state: {
                                                from: "addMorePointToRoute",
                                                data: location?.state?.data,
                                                categoryName: "tzadikim",
                                              },
                                            }
                                          );
                                        } else {
                                          navigate(
                                            `/category-detail/?MkmId=${place?.mkmID}&cor=${place?.poi}`,
                                            {
                                              state: {
                                                from: "addMorePointToRoute",
                                                data: location?.state?.data,
                                                categoryName: Place1?.title,
                                              },
                                            }
                                          );
                                        }
                                      }}
                                    >
                                      {/* Image Section */}
                                      <div className="nt-card-image">
                                        <img
                                          src={
                                            place?.imageIDs?.length > 0
                                              ? `${API_URL}/api/mkm/getimage/${Place1?.imageIDs?.[0]}`
                                              : categoryItems.find(
                                                  (items) =>
                                                    items.title ===
                                                    Place1?.title
                                                )?.icon
                                          }
                                          alt="placeholder"
                                        />
                                      </div>

                                      {/* Dropdown */}
                                      <div className="nt-dropdown_list">
                                        <Dropdown
                                          className="nt-moreInfo"
                                          toggle={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setMenuOpen(
                                              index === dropdownMenuOpen
                                                ? null
                                                : index
                                            );
                                          }}
                                          isOpen={index === dropdownMenuOpen}
                                        >
                                          <DropdownToggle
                                            className="nt-list_icon"
                                            caret={false}
                                          >
                                            <HiDotsVertical className="nt-list" />
                                          </DropdownToggle>

                                          <DropdownMenu
                                            className="nt-custom_dropdown"
                                            modifiers={[
                                              {
                                                name: "offset",
                                                options: { offset: [-155, 5] },
                                              },
                                            ]}
                                          >
                                            <DropdownItem>
                                              <Link
                                                to={`/along-the-way-to-here/${place?.poi}`}
                                                state={{
                                                  from: "addMorePointToRoute",
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1 hello"
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                }
                                              >
                                                <IoNavigateSharp
                                                  className="navigate_icon"
                                                  size={"18px"}
                                                />
                                                Along the way to here
                                              </Link>
                                            </DropdownItem>
                                            <DropdownItem
                                              className="nt-report-suggestion"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                reportSuggestion(
                                                  place?.title,
                                                  place?.tzadikimID
                                                    ? place?.tzadikimID
                                                    : place?.mkmID
                                                );
                                              }}
                                            >
                                              <MdOutlineFeedback size={17} />
                                              Report suggestion
                                            </DropdownItem>
                                          </DropdownMenu>
                                        </Dropdown>
                                      </div>

                                      {/* Card Details */}
                                      <div className="nt-card-details">
                                        <div
                                          className="nt-share-icon"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            share(
                                              place?.tzadikimID
                                                ? place?.tzadikimID
                                                : place?.mkmID,
                                              place?.poi
                                            );
                                          }}
                                        >
                                          <IoShareSocial />
                                        </div>

                                        <div className="nt-title">
                                          {Place1?.title === "Tzadikim" ? (
                                            <h3>
                                              <Link
                                                to={`/category-detail/?tzadikimId=${place?.tzadikimID}&cor=${place?.poi}`}
                                                state={{
                                                  from: "addMorePointToRoute",
                                                  data: location?.state?.data,
                                                  categoryName: "tzadikim",
                                                }}
                                                title={place?.title}
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                }
                                              >
                                                {place?.title}
                                              </Link>
                                            </h3>
                                          ) : (
                                            <h3>
                                              <Link
                                                to={`/category-detail/?MkmId=${place?.mkmID}&cor=${place?.poi}`}
                                                state={{
                                                  from: "addMorePointToRoute",
                                                  data: location?.state?.data,
                                                  categoryName: Place1?.title,
                                                }}
                                                title={place?.title}
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                }
                                              >
                                                {place?.title}
                                              </Link>
                                            </h3>
                                          )}

                                          <h4>
                                            {place?.cityY
                                              ? place?.cityY.substring(
                                                  place?.cityY.indexOf("/") + 1
                                                )
                                              : null}
                                            {place?.stateY
                                              ? " - " +
                                                place?.stateY.substring(
                                                  place?.stateY.indexOf("/") + 1
                                                )
                                              : null}
                                          </h4>
                                        </div>
                                      </div>

                                      {/* Footer */}
                                      <div className="nt-card-footer">
                                        <div className="nt-card_footer-left-side">
                                          <div className="nt-location">
                                            <HiLocationMarker
                                              color="#618FFB"
                                              size={20}
                                            />
                                            <span>
                                              {place?.cityE +
                                                " " +
                                                place?.stateE}
                                            </span>
                                          </div>
                                          <button
                                            className="nt-btn-learn-more"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <Link to="##">Learn More</Link>
                                          </button>
                                        </div>

                                        {/* Add to Route */}
                                        <div className="nt-add_fav">
                                          {routePoint.filter(
                                            (item) =>
                                              item?.place?.mkmID ===
                                                place?.mkmID ||
                                              item.mkmID === place?.mkmID
                                          ).length > 0 ? (
                                            <button
                                              className="add-toRoute"
                                              onClick={(e) =>
                                                e.stopPropagation()
                                              }
                                            >
                                              <IoCheckmark />
                                            </button>
                                          ) : (
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                addToRoute(place?.mkmID);
                                              }}
                                            >
                                              <GoPlus size={30} />
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )
                              )}

                              {/* Load More */}
                              {Place1.items?.length > myIndex[idx] ? (
                                <div className="load_more_btn">
                                  <Button
                                    color="primary"
                                    onClick={() => loadMore(idx)}
                                  >
                                    Load more
                                  </Button>
                                </div>
                              ) : null}
                            </div>
                          </section>
                        </div>
                      </div>
                    );
                  })
                : null}
            </div>
          </div>
        </ContainerLayout>
      </div>
      {(AllPlaces.length === 0 && currentTableData.length === 0) ||
      currentTableData === undefined ? (
        <div className="nt-categories-container">
          {categoryItems.map((category, index) => (
            <div
              onClick={() =>
                navigate("/add-more-points-to-route-category-list", {
                  state: {
                    previousPageData: location.state?.data,

                    id: category.id,
                    title: category.title,
                    subTitle: category.showTitle,
                    categoryName: category?.title,
                    categoryTitle: category?.showTitle,
                    categoryIcon: category.icon,
                    categoryItem: categoryItem,
                    isUserLoggedIn: isUserLoggedIn,
                    categroyData: category,
                    currentPage: "currentPage",
                    // routePointss: "location?.state",
                  },
                })
              }
              className="nt-category-item"
              key={category.id}
              state={{
                categoryName: category.title,
                categoryTitle: category.showTitle,
                categoryIcon: category.icon,
                key: category.id,
              }}
              // onMouseOver={() =>
              //   setIsHover({
              //     hoverKeyName: index,
              //     hoverValue: (
              //       <img
              //         src={arrow_icon}
              //         className="nt-arrow_icon"
              //         alt=""
              //       ></img>
              //     ),
              //   })
              // }
              // onMouseOut={() => setIsHover("")}
            >
              <img
                className="nt-category-image"
                src={category.src}
                alt={category.title}
              />
              <p className="nt-category-title">
                {category.showTitle}{" "}
                {isHover?.hoverKeyName === index ? isHover?.hoverValue : null}
              </p>
            </div>
          ))}
        </div>
      ) : null}

      {/* <Button
        className="btn explorebot"
        onClick={() => {
          window.location.href =
            "/my-routes-detail/" +
            location?.state?.data[0]?.route_id +
            "/" +
            location?.state?.data[0]?.route_name;
        }}
      >
        <AiOutlineArrowLeft size={40} color="red" />
      </Button> */}
    </div>
  );
}

export default AddMorePointsToRoute;
